export const queryString = function (key, ignoreCase = true, targetKey = 'search') {
  if (typeof window === 'undefined' || !key) {
    return;
  }
  if (['hash', 'search'].every((e) => e != targetKey)) {
    targetKey = 'search';
  }
  const str = window.location[targetKey] || '';
  if (str && str.split('?')[1]) {
    const queryArray = str.split('?')[1].split('&');
    for (let n = 0; n < queryArray.length; n++) {
      const temp = queryArray[n].split('=');
      if (temp.length > 1) {
        if (temp[0] == key || (ignoreCase && temp[0].toLowerCase() == key.toLowerCase())) return temp[1];
      }
    }
  }
  return null;
};

export const newGuid = function () {
  let guid = '';
  for (let i = 1; i <= 32; i++) {
    const n = Math.floor(Math.random() * 16.0).toString(16);
    guid += n;
    if (i == 8 || i == 12 || i == 16 || i == 20) guid += '-';
  }
  return guid;
};
